module.exports = __webpack_public_path__ + "media/images/payments/dwolla-d89193666cbc922f58c07fdca98ff594.svg";